import React from "react";
import { CampLocation } from "@/types/campLocation";
import { Offer } from "@/types/offer";
import { SortableOption } from "@/types/fieldsOptions"; 
import { OfferFormDialogController } from "./dialogs/OfferFormDialogController";

interface OfferFormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (offerData: any) => void;
  onDelete?: (offerId: string) => void;
  initialDate?: Date;
  location: CampLocation;
  initialOffer?: Offer | null;
  lastOfferByVariation?: Record<string, Offer>;
  availabilityStatusOptions?: SortableOption[]; 
  signupStatusOptions?: SortableOption[];
  isCopyOperation?: boolean;
  savedFormData?: any;
  savedAddAnotherChecked?: boolean;
}

export const OfferFormDialog: React.FC<OfferFormDialogProps> = (props) => {
  return <OfferFormDialogController {...props} />;
};
